import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
    if (typeof window.loadPostHog === "function") {
      window.loadPostHog();
    }
  };

  const decline = () => {
    localStorage.setItem("cookie_consent", "declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6"
          data-testid="cookie-banner"
        >
          <div className="max-w-4xl mx-auto bg-lab-bg-dark border border-white/10 shadow-2xl p-5 sm:p-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-lab-accent/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Cookie className="w-5 h-5 text-lab-accent" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-white font-medium text-sm mb-1">Cookie-Einstellungen</h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Wir verwenden technisch notwendige Cookies sowie Analyse-Cookies (PostHog), um unsere Website zu verbessern.
                  Weitere Infos finden Sie in unserer{" "}
                  <a href="/datenschutz" className="text-lab-accent hover:underline">Datenschutzerklärung</a>.
                </p>
              </div>
              <button
                onClick={decline}
                className="text-gray-500 hover:text-white flex-shrink-0"
                data-testid="cookie-close"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="flex items-center justify-end gap-3 mt-4">
              <button
                onClick={decline}
                className="px-4 py-2 text-sm text-gray-400 hover:text-white border border-white/20 hover:border-white/40 transition-colors"
                data-testid="cookie-decline"
              >
                Nur notwendige
              </button>
              <button
                onClick={accept}
                className="px-4 py-2 text-sm bg-lab-accent text-lab-primary font-medium hover:bg-white transition-colors"
                data-testid="cookie-accept"
              >
                Alle akzeptieren
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

// Export a function to reset consent (for "Cookie-Einstellungen" link)
export const resetCookieConsent = () => {
  localStorage.removeItem("cookie_consent");
  window.location.reload();
};

export default CookieBanner;
